import React from "react";
import { Link } from "react-router-dom";
import { BLOG_POSTS } from "../lib/data";
import { ArrowUpRight } from "lucide-react";

export default function Blog() {
  return (
    <div data-testid="blog-page">
      <section className="py-24 sm:py-32 border-b border-zinc-200">
        <div className="container-oj">
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-zinc-500">Insights</div>
          <h1 className="font-display mt-4 text-5xl sm:text-7xl font-black tracking-tighter leading-[0.92] text-oj-ink max-w-3xl">
            Field notes from the floor.
          </h1>
        </div>
      </section>

      <section className="py-16 sm:py-24 bg-white">
        <div className="container-oj grid grid-cols-1 md:grid-cols-3 gap-6">
          {BLOG_POSTS.map((p) => (
            <Link
              to={`/blog/${p.slug}`}
              key={p.slug}
              data-testid={`blog-${p.slug}`}
              className="group rounded-2xl border border-zinc-200 p-8 bg-white hover:bg-zinc-50 transition-colors"
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <span className="h-2 w-2 rounded-full" style={{ background: p.color }} />
                  <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500">{p.category}</span>
                </div>
                <ArrowUpRight className="size-4 text-zinc-500 group-hover:text-oj-ink" />
              </div>
              <h3 className="mt-5 font-display text-2xl font-bold text-oj-ink leading-tight">{p.title}</h3>
              <p className="mt-3 text-zinc-600 text-sm leading-relaxed">{p.excerpt}</p>
              <div className="mt-6 text-xs text-zinc-500">{new Date(p.date).toLocaleDateString()} · {p.read_minutes} min</div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
